import $api from '../../utils/api.js'

const state = () => ({
    waitinglist: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Code & Title'
    },
    form_waitinglist:{
        id:'',
        title:'',
        person_category:'',
        type:'WEDDING',
        package:'',
        date:'',
        code:'',
        json:'',
    }
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.waitinglist = payload
    },
    ASSIGN_DATA_APPROVE_WAITINGLIST(state, payload) {
        state.form_waitinglist = payload
    },
    ASSIGN_FORM(state, payload) {
        state.form_waitinglist = payload
    },
    CLEAR_WAITINGLIST(state){
        state.waitinglist = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    CLEAR_FORM(state){
        state.form_waitinglist = {
            id:'',
            title:'',
            person_category:'',
            type:'WEDDING',
            package:'',
            date:'',
            code:'',
            json:'',
        }
    }
}

const actions = {
    getWaitinglist({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`waitinglist?page=${state.waitinglist.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createWaitinglist({state }) {
        return new Promise((resolve,reject) => {
            $api.post(`waitinglist`, state.form_waitinglist)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateWaitinglist({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`waitinglist/${payload}`,state.form_waitinglist)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    resetWaitinglist(_, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`reset-waitinglist/${payload}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteWaitinglist({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`waitinglist/${payload}`)
            .then(() => {
                dispatch('getWaitinglist').then(() => resolve())
            })
        })
    },
    approveWaitinglist({state }) {
        return new Promise((resolve,reject) => {
            $api.put(`approve-waitinglist`, state.form_waitinglist)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}